export const articles = [
  {
    id: 1,
    slug: "hipobuy-ultimate-guide-2026",
    title: "HipoBuy 2026 Ultimate Shopping Guide: How to Choose Premium Replica Fashion",
    excerpt: "Discover everything you need to know about shopping on HipoBuy 2026. From product selection to delivery, this comprehensive guide covers it all for savvy shoppers.",
    category: "Guide",
    date: "2026-03-15",
    readTime: "8 min read",
    image: "https://public.readdy.ai/ai/img_res/8795c1b4244004964068af8855c38488.jpg",
  },
  {
    id: 2,
    slug: "replica-shoes-buying-guide",
    title: "Replica Shoes Buying Guide: Sizing, Quality & Authentication Tips",
    excerpt: "Everything you need to know before buying replica shoes online. Learn how to check sizing charts, verify quality, and spot the best deals on HipoBuy.",
    category: "Shoes",
    date: "2026-03-10",
    readTime: "6 min read",
    image: "https://readdy.ai/api/search-image?query=replica%20sneakers%20shoes%20collection%20display%20clean%20white%20background%20fashion%20photography&width=800&height=500&seq=art002&orientation=landscape",
  },
  {
    id: 3,
    slug: "hipobuy-vs-competitors",
    title: "HipoBuy vs Competitors: Why HipoBuy 2026 Is Your Best Choice",
    excerpt: "A detailed comparison of HipoBuy 2026 against other replica fashion platforms. See why thousands of shoppers trust HipoBuy for quality and reliability.",
    category: "Review",
    date: "2026-03-05",
    readTime: "7 min read",
    image: "https://readdy.ai/api/search-image?query=fashion%20comparison%20shopping%20platform%20review%20modern%20minimalist%20design&width=800&height=500&seq=art003&orientation=landscape",
  },
  {
    id: 4,
    slug: "hoodie-sizing-chart-guide",
    title: "Hoodie & Sweater Sizing Chart Guide: Get the Perfect Fit Every Time",
    excerpt: "Never order the wrong size again. Our complete hoodie and sweater sizing guide helps you find the perfect fit when shopping replica fashion on HipoBuy.",
    category: "Hoodies",
    date: "2026-02-28",
    readTime: "5 min read",
    image: "https://readdy.ai/api/search-image?query=hoodie%20sweater%20sizing%20fashion%20guide%20clean%20background%20clothing%20display&width=800&height=500&seq=art004&orientation=landscape",
  },
  {
    id: 5,
    slug: "tshirt-quality-check-tips",
    title: "T-Shirt Quality Check Tips: How to Identify Premium Replica Products",
    excerpt: "Learn the expert techniques for checking t-shirt quality when shopping on HipoBuy 2026. From fabric weight to stitching, we cover all the key indicators.",
    category: "T-Shirts",
    date: "2026-02-20",
    readTime: "5 min read",
    image: "https://readdy.ai/api/search-image?query=tshirt%20quality%20check%20fashion%20photography%20clean%20white%20background%20premium%20clothing&width=800&height=500&seq=art005&orientation=landscape",
  },
  {
    id: 6,
    slug: "jacket-care-maintenance",
    title: "Jacket Care & Maintenance Guide: Extend the Life of Your Replica Outerwear",
    excerpt: "Proper care can double the lifespan of your replica jackets. Follow our expert maintenance guide to keep your HipoBuy purchases looking brand new.",
    category: "Jackets",
    date: "2026-02-15",
    readTime: "6 min read",
    image: "https://readdy.ai/api/search-image?query=jacket%20care%20maintenance%20fashion%20outerwear%20clean%20background%20premium%20quality&width=800&height=500&seq=art006&orientation=landscape",
  },
  {
    id: 7,
    slug: "pants-fit-guide-2026",
    title: "Pants & Shorts Fit Guide 2026: Best Styles for Every Body Type",
    excerpt: "Find the perfect pants and shorts for your body type with our 2026 fit guide. HipoBuy offers a wide range of styles to suit every preference and occasion.",
    category: "Pants",
    date: "2026-02-10",
    readTime: "6 min read",
    image: "https://readdy.ai/api/search-image?query=pants%20shorts%20fashion%20fit%20guide%20body%20type%20styling%20clean%20background&width=800&height=500&seq=art007&orientation=landscape",
  },
  {
    id: 8,
    slug: "headwear-style-trends",
    title: "Headwear Style Trends 2026: Must-Have Caps, Hats & Beanies",
    excerpt: "Stay ahead of the fashion curve with our 2026 headwear trend report. Discover the hottest caps, hats, and beanies available on HipoBuy this season.",
    category: "Headwear",
    date: "2026-02-05",
    readTime: "5 min read",
    image: "https://readdy.ai/api/search-image?query=headwear%20caps%20hats%20beanies%20fashion%20trends%202026%20clean%20background%20display&width=800&height=500&seq=art008&orientation=landscape",
  },
  {
    id: 9,
    slug: "matching-sets-outfit-ideas",
    title: "Matching Sets Outfit Ideas: Create Perfect Replica Fashion Looks",
    excerpt: "Elevate your style game with coordinated matching sets from HipoBuy 2026. Our outfit inspiration guide shows you how to put together stunning looks effortlessly.",
    category: "Sets",
    date: "2026-01-30",
    readTime: "7 min read",
    image: "https://readdy.ai/api/search-image?query=matching%20sets%20outfit%20fashion%20coordination%20styling%20clean%20white%20background&width=800&height=500&seq=art009&orientation=landscape",
  },
  {
    id: 10,
    slug: "underwear-comfort-guide",
    title: "Underwear Comfort Guide: Choosing the Right Undergarments on HipoBuy",
    excerpt: "Comfort starts from the inside out. Our comprehensive underwear guide helps you select the best undergarments from HipoBuy 2026 for all-day comfort.",
    category: "Underwear",
    date: "2026-01-25",
    readTime: "5 min read",
    image: "https://readdy.ai/api/search-image?query=underwear%20comfort%20fashion%20guide%20clean%20background%20minimalist%20product%20display&width=800&height=500&seq=art010&orientation=landscape",
  },
  {
    id: 11,
    slug: "jersey-authentication-tips",
    title: "Jersey Authentication Tips: How to Spot Quality Replica Sports Jerseys",
    excerpt: "Sports jersey shopping made easy. Learn how to identify high-quality replica jerseys on HipoBuy 2026 with our expert authentication and quality tips.",
    category: "Jersey",
    date: "2026-01-20",
    readTime: "6 min read",
    image: "https://readdy.ai/api/search-image?query=sports%20jersey%20authentication%20quality%20check%20fashion%20photography%20clean%20background&width=800&height=500&seq=art011&orientation=landscape",
  },
  {
    id: 12,
    slug: "accessories-complete-look",
    title: "Accessories Complete Look: Elevate Any Outfit with HipoBuy Accessories",
    excerpt: "The right accessories can transform any outfit. Discover how to use HipoBuy 2026 accessories to complete your look and express your personal style.",
    category: "Accessories",
    date: "2026-01-15",
    readTime: "5 min read",
    image: "https://readdy.ai/api/search-image?query=fashion%20accessories%20complete%20look%20styling%20belts%20bags%20hats%20clean%20background&width=800&height=500&seq=art012&orientation=landscape",
  },
  {
    id: 13,
    slug: "hipobuy-shipping-explained",
    title: "HipoBuy Shipping Explained: Delivery Times, Costs & Tracking",
    excerpt: "Everything you need to know about HipoBuy shipping. From processing times to international delivery options, we break down the complete shipping process.",
    category: "Shipping",
    date: "2026-01-10",
    readTime: "7 min read",
    image: "https://readdy.ai/api/search-image?query=shipping%20delivery%20logistics%20package%20tracking%20modern%20clean%20background&width=800&height=500&seq=art013&orientation=landscape",
  },
  {
    id: 14,
    slug: "payment-security-guide",
    title: "Payment Security Guide: Safe Shopping Practices on HipoBuy 2026",
    excerpt: "Shop with confidence on HipoBuy 2026. Our payment security guide covers all the best practices for safe online transactions and protecting your financial information.",
    category: "Security",
    date: "2026-01-05",
    readTime: "6 min read",
    image: "https://readdy.ai/api/search-image?query=payment%20security%20online%20shopping%20safe%20transaction%20modern%20clean%20background&width=800&height=500&seq=art014&orientation=landscape",
  },
  {
    id: 15,
    slug: "return-refund-policy",
    title: "Return & Refund Policy: Your Complete Rights as a HipoBuy Customer",
    excerpt: "Understanding your rights as a HipoBuy 2026 customer. Our detailed return and refund policy guide ensures you know exactly what to expect when shopping with us.",
    category: "Policy",
    date: "2025-12-28",
    readTime: "5 min read",
    image: "https://readdy.ai/api/search-image?query=return%20refund%20policy%20customer%20service%20fashion%20shopping%20clean%20background&width=800&height=500&seq=art015&orientation=landscape",
  },
  {
    id: 16,
    slug: "seasonal-fashion-trends",
    title: "Seasonal Fashion Trends 2026: Must-Have Replica Items for Every Season",
    excerpt: "Stay stylish year-round with our 2026 seasonal fashion trend guide. Discover the hottest replica fashion items for spring, summer, fall, and winter on HipoBuy.",
    category: "Trends",
    date: "2025-12-20",
    readTime: "8 min read",
    image: "https://readdy.ai/api/search-image?query=seasonal%20fashion%20trends%202026%20clothing%20collection%20clean%20background%20stylish&width=800&height=500&seq=art016&orientation=landscape",
  },
  {
    id: 17,
    slug: "budget-shopping-tips",
    title: "Budget Shopping Tips: Get the Most Value from HipoBuy 2026",
    excerpt: "Maximize your shopping budget with our expert tips for finding the best deals on HipoBuy 2026. Learn how to get premium replica fashion without breaking the bank.",
    category: "Tips",
    date: "2025-12-15",
    readTime: "6 min read",
    image: "https://readdy.ai/api/search-image?query=budget%20shopping%20tips%20fashion%20deals%20value%20money%20saving%20clean%20background&width=800&height=500&seq=art017&orientation=landscape",
  },
  {
    id: 18,
    slug: "first-time-buyer-guide",
    title: "First-Time Buyer Guide: Everything You Need to Know About HipoBuy",
    excerpt: "New to HipoBuy 2026? This comprehensive first-time buyer guide walks you through every step of the shopping process, from browsing to receiving your order.",
    category: "Guide",
    date: "2025-12-10",
    readTime: "9 min read",
    image: "https://readdy.ai/api/search-image?query=first%20time%20buyer%20guide%20online%20shopping%20fashion%20beginner%20clean%20background&width=800&height=500&seq=art018&orientation=landscape",
  },
  {
    id: 19,
    slug: "customer-success-stories",
    title: "Customer Success Stories: Real HipoBuy 2026 Shopping Experiences",
    excerpt: "Read real customer success stories from HipoBuy 2026 shoppers worldwide. Discover how our customers found their perfect replica fashion items and saved money.",
    category: "Reviews",
    date: "2025-12-05",
    readTime: "7 min read",
    image: "https://readdy.ai/api/search-image?query=customer%20success%20stories%20reviews%20fashion%20shopping%20happy%20customers%20clean%20background&width=800&height=500&seq=art019&orientation=landscape",
  },
  {
    id: 20,
    slug: "hipobuy-2026-roadmap",
    title: "HipoBuy 2026 Roadmap: Upcoming Features & Services",
    excerpt: "Get an exclusive look at what HipoBuy 2026 has planned for the future. From new product categories to enhanced shipping options, exciting updates are coming.",
    category: "News",
    date: "2025-11-30",
    readTime: "5 min read",
    image: "https://readdy.ai/api/search-image?query=roadmap%20future%20plans%20fashion%20platform%202026%20modern%20clean%20background%20technology&width=800&height=500&seq=art020&orientation=landscape",
  },
];

export const categories = [
  { name: "Shoes", url: "https://repsw2c.com/category-911-Shoes.html", icon: "ri-footprint-line" },
  { name: "Hoodies/Sweaters", url: "https://repsw2c.com/search-912/name/Shoes.html", icon: "ri-shirt-line" },
  { name: "T-Shirts", url: "https://repsw2c.com/search-913/name/Shoes.html", icon: "ri-t-shirt-line" },
  { name: "Jackets", url: "https://repsw2c.com/search-914/name/Shoes.html", icon: "ri-windy-line" },
  { name: "Pants/Shorts", url: "https://repsw2c.com/search-915/name/Shoes.html", icon: "ri-layout-bottom-line" },
  { name: "Headwear", url: "https://repsw2c.com/search-916/name/Shoes.html", icon: "ri-user-smile-line" },
  { name: "Sets", url: "https://repsw2c.com/search-917/name/Shoes.html", icon: "ri-stack-line" },
  { name: "Underwear/Underpants", url: "https://repsw2c.com/search-918/name/Shoes.html", icon: "ri-heart-line" },
  { name: "Jersey", url: "https://repsw2c.com/search-919/name/Shoes.html", icon: "ri-medal-line" },
  { name: "Accessories", url: "https://repsw2c.com/search-920/name/Shoes.html", icon: "ri-handbag-line" },
];

export const categoryImages = [
  "https://readdy.ai/api/search-image?query=premium%20replica%20sneakers%20shoes%20collection%20white%20clean%20background%20fashion%20photography&width=400&height=400&seq=cat001&orientation=squarish",
  "https://readdy.ai/api/search-image?query=hoodie%20sweater%20collection%20fashion%20display%20clean%20white%20background%20streetwear&width=400&height=400&seq=cat002&orientation=squarish",
  "https://readdy.ai/api/search-image?query=tshirt%20collection%20fashion%20display%20clean%20white%20background%20premium%20quality&width=400&height=400&seq=cat003&orientation=squarish",
  "https://readdy.ai/api/search-image?query=jacket%20outerwear%20collection%20fashion%20display%20clean%20white%20background%20premium&width=400&height=400&seq=cat004&orientation=squarish",
  "https://readdy.ai/api/search-image?query=pants%20shorts%20collection%20fashion%20display%20clean%20white%20background%20streetwear&width=400&height=400&seq=cat005&orientation=squarish",
  "https://readdy.ai/api/search-image?query=caps%20hats%20headwear%20collection%20fashion%20display%20clean%20white%20background&width=400&height=400&seq=cat006&orientation=squarish",
  "https://readdy.ai/api/search-image?query=matching%20sets%20outfit%20collection%20fashion%20display%20clean%20white%20background&width=400&height=400&seq=cat007&orientation=squarish",
  "https://readdy.ai/api/search-image?query=underwear%20comfort%20fashion%20collection%20clean%20white%20background%20minimalist&width=400&height=400&seq=cat008&orientation=squarish",
  "https://readdy.ai/api/search-image?query=sports%20jersey%20collection%20fashion%20display%20clean%20white%20background%20athletic&width=400&height=400&seq=cat009&orientation=squarish",
  "https://readdy.ai/api/search-image?query=fashion%20accessories%20belts%20bags%20collection%20clean%20white%20background%20premium&width=400&height=400&seq=cat010&orientation=squarish",
];
